import { Component } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { APP_NAME } from '@core/constants/constant.data'
import { TOOLCHAIN_SCENARIOS } from '../toolchain-scenarios/toolchain-scenarios.data'

@Component({
  selector: 'app-toolchain-scenarios',
  templateUrl: './toolchain-scenarios.component.html',
  styleUrls: ['./toolchain-scenarios.component.scss'],
  imports: [
    // Material
    MatTooltipModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ToolchainScenariosComponent {
  toolchainScenarios = TOOLCHAIN_SCENARIOS.filter((cms) => cms.project.includes(APP_NAME))
}
